import { render, staticRenderFns } from "./MatVoteIcon.vue?vue&type=template&id=d5f61fa0&scoped=true"
import script from "./MatVoteIcon.vue?vue&type=script&lang=js"
export * from "./MatVoteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f61fa0",
  null
  
)

export default component.exports